import { FormWithRedux } from '../../FormWithRedux';
import { OsteoporosisInformationForm } from './Osteoporosis-InformationForm';

export class OsteoporosisIntroForm extends FormWithRedux {

    constructor() {
        super('introForm');
    }

    generateSubform(identifier) {
        switch (identifier) {
            case 'PathwayInformationForm':
                return new OsteoporosisInformationForm();
        }
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return null;
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return this.detail;
    }
}


// WEBPACK FOOTER //
// ./src/forms/dxaScan01/IntroForm/Osteoporosis-IntroForm.js